var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_3447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.52338 12.9768C3.65428 12.8459 3.83426 12.7695 4.02515 12.7695H21.336C21.6524 12.7695 21.8105 13.1513 21.5869 13.3749L18.1673 16.7946C18.0364 16.9254 17.8564 17.0018 17.6655 17.0018H0.35463C0.0383006 17.0018 -0.119864 16.62 0.103748 16.3964L3.52338 12.9768Z",
    fill: "url(#paint0_linear_641_3447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52338 0.207251C3.65973 0.0763555 3.83971 0 4.02515 0H21.336C21.6524 0 21.8105 0.381777 21.5869 0.60539L18.1673 4.02502C18.0364 4.15592 17.8564 4.23227 17.6655 4.23227H0.35463C0.0383006 4.23227 -0.119864 3.8505 0.103748 3.62688L3.52338 0.207251Z",
    fill: "url(#paint1_linear_641_3447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1673 6.551C18.0364 6.42011 17.8564 6.34375 17.6655 6.34375H0.35463C0.0383006 6.34375 -0.119864 6.72553 0.103748 6.94914L3.52338 10.3688C3.65428 10.4997 3.83426 10.576 4.02515 10.576H21.336C21.6524 10.576 21.8105 10.1942 21.5869 9.97063L18.1673 6.551Z",
    fill: "url(#paint2_linear_641_3447)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_3447",
    x1: 19.6823,
    y1: -2.04099,
    x2: 7.70182,
    y2: 20.9065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_641_3447",
    x1: 14.4438,
    y1: -4.77775,
    x2: 2.46329,
    y2: 18.1697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_641_3447",
    x1: 17.0464,
    y1: -3.41819,
    x2: 5.06588,
    y2: 19.5293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_3447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6904,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.351d4efe32981f01f961be2a143e9755.svg";
export { ForwardRef as ReactComponent };